import '../LandingPage.css';

function HeroSection() {
  return (
    <section className="hero-section">
      <div className="hero-bg" aria-hidden="true">
        <span className="hero-blob hero-blob--1"></span>
        <span className="hero-blob hero-blob--2"></span>
        <span className="hero-blob hero-blob--3"></span>
        <span className="hero-grid"></span>
      </div>

      <div className="hero-content">
        <span className="hero-badge reveal">
          <span className="hero-badge-dot"></span>
          20+ years building software
        </span>

        <h1 className="hero-title reveal reveal-delay-1">
          Expert software development
          <span className="hero-title-accent"> solutions</span>
        </h1>

        <p className="hero-subtitle reveal reveal-delay-2">
          We design and build robust, scalable web applications tailored to your
          business — from healthcare and finance to e-commerce.
        </p>

        <div className="hero-actions reveal reveal-delay-3">
          <a href="#contact" className="btn btn--primary">
            Start a project
          </a>
          <a href="#about" className="btn btn--ghost">
            Learn more
          </a>
        </div>

        <div className="hero-stats reveal reveal-delay-4">
          <div className="hero-stat">
            <span className="hero-stat-value">20+</span>
            <span className="hero-stat-label">Years of experience</span>
          </div>
          <div className="hero-stat">
            <span className="hero-stat-value">3+</span>
            <span className="hero-stat-label">Industries served</span>
          </div>
          <div className="hero-stat">
            <span className="hero-stat-value">100%</span>
            <span className="hero-stat-label">Tailored solutions</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
